const ENV = process.env.REACT_APP_ENV || 'dev';

const API_BASE_URL =
  ENV === 'prod'
    ? process.env.REACT_APP_API_BASE_URL_PROD
    : ENV === 'stage'
    ? process.env.REACT_APP_API_BASE_URL_STAGE
    : process.env.REACT_APP_API_BASE_URL_DEV;


export const API_GATEWAY_URL = `${API_BASE_URL}:3000/`;
export const API_EVENT_URL = `${API_BASE_URL}:3014/`;
export const API_LOGIN_URL = `${API_BASE_URL}:3013/api/v1/event-user/login`;
export const API_FORGOT_URL = `${API_BASE_URL}:3013/api/v1/event-user/reset-passowrd`;
export const API_RESET_URL = `${API_BASE_URL}:3000/api/event-user/reset-passowrd/update`;
export const API_SCHEDULE_URL = `${API_BASE_URL}:3000/frontend/api/live-presentation/event-id/675fed63be9d330491dc8f1c`;
export const API_EDIT_PROFILE_URL = `${API_BASE_URL}:3000/frontend/api/event-user/profile/`;
export const API_UPDATE_PASSWORD = `${API_BASE_URL}:3000/frontend/api/event-user/change-password`;
export const API_EVENT_USERS_URL_EMAIL = `${API_BASE_URL}:3013/api/v1/`;

export const IMAGES_BASE_PATH = process.env.REACT_APP_S3_BUCKET!;
export const BUILD_VERSION = 1.1;
export const ASSET_URL = `${API_BASE_URL}:3011/`;
